import OrderOptimizerDetailsCargoResponse, {
  OrderOptimizerDetailsCargoResponseItemStepsOrdersPoints,
  OrderOptimizerDetailsCargoResponseItemStepsOrders,
  OrderOptimizerDetailsCargoResponseItemSteps,
  OrderOptimizerDetailsCargoResponseItemOrders,
  OrderOptimizerDetailsCargoResponseItemOptimizedStats,
  OrderOptimizerDetailsCargoResponseItemUnoptimizedStats,
  OrderOptimizerDetailsCargoResponseItemStepsLastPoint,
} from "../../../../api/raily/order-optimizer/details/cargo/order-optimizer-details-cargo.response";
import OrderOptimizerDetailsCargo, {
  OrderOptimizerDetailsCargoStepsOrdersPoints,
  OrderOptimizerDetailsCargoStepsOrders,
  OrderOptimizerDetailsCargoStepsLastPoint,
  OrderOptimizerDetailsCargoSteps,
  OrderOptimizerDetailsCargoOrders,
  OrderOptimizerDetailsCargoOptimizedStats,
  OrderOptimizerDetailsCargoUnoptimizedStats,
} from "./order-optimizer-details-cargo";

const createStepsOrderPoint = (
  stepsOrderPoint: OrderOptimizerDetailsCargoResponseItemStepsOrdersPoints
): OrderOptimizerDetailsCargoStepsOrdersPoints => {
  const point: OrderOptimizerDetailsCargoStepsOrdersPoints = {
    displayName: stepsOrderPoint.displayName,
    distance: stepsOrderPoint.distance,
    haltingTime: stepsOrderPoint.haltingTime,
    lat: stepsOrderPoint.lat,
    lon: stepsOrderPoint.lon,
    time: stepsOrderPoint.time,
  };

  return point;
};

const createStepsOrderPoints = (
  stepsOrderPoints: OrderOptimizerDetailsCargoResponseItemStepsOrdersPoints[]
): OrderOptimizerDetailsCargoStepsOrdersPoints[] => {
  return stepsOrderPoints.map(createStepsOrderPoint);
};

const createStepsLastPoint = (
  stepsLastPoint: OrderOptimizerDetailsCargoResponseItemStepsLastPoint | null
): OrderOptimizerDetailsCargoStepsLastPoint | null => {
  if (!stepsLastPoint) return null;
  const lastPoint = {
    displayName: stepsLastPoint.displayName,
    time: stepsLastPoint.time,
    haltingTime: stepsLastPoint.haltingTime,
    distance: stepsLastPoint.distance,
    lat: stepsLastPoint.lat,
    lon: stepsLastPoint.lon,
  };
  return lastPoint;
};

const createStepsOrder = (
  stepsOrder: OrderOptimizerDetailsCargoResponseItemStepsOrders
): OrderOptimizerDetailsCargoStepsOrders => {
  const order = {
    distance: stepsOrder.distance,
    haltingTime: stepsOrder.haltingTime,
    points: createStepsOrderPoints(stepsOrder.points),
    totalTime: stepsOrder.totalTime,
  };

  return order;
};

const createStepsOrders = (
  stepsOrders: OrderOptimizerDetailsCargoResponseItemStepsOrders[]
): OrderOptimizerDetailsCargoStepsOrders[] => {
  return stepsOrders.map(createStepsOrder);
};

const createSteps = (
  steps: OrderOptimizerDetailsCargoResponseItemSteps
): OrderOptimizerDetailsCargoSteps => {
  const detailsSteps = {
    orders: createStepsOrders(steps.orders),
    lastPoint: createStepsLastPoint(steps.lastPoint),
  };
  return detailsSteps;
};

const createOptimizedStats = (
  optimizedStats: OrderOptimizerDetailsCargoResponseItemOptimizedStats
): OrderOptimizerDetailsCargoOptimizedStats => {
  const stats = {
    distance: optimizedStats.distance,
    haltingTime: optimizedStats.haltingTime,
    saving: optimizedStats.saving,
    totalTime: optimizedStats.totalTime,
  };
  return stats;
};

const createUnoptimizedStats = (
  optimizedStats: OrderOptimizerDetailsCargoResponseItemUnoptimizedStats
): OrderOptimizerDetailsCargoUnoptimizedStats => {
  const stats = {
    distance: optimizedStats.distance,
    haltingTime: optimizedStats.haltingTime,
    saving: optimizedStats.saving,
    totalTime: optimizedStats.totalTime,
  };
  return stats;
};

const createOrder = (
  order: OrderOptimizerDetailsCargoResponseItemOrders
): OrderOptimizerDetailsCargoOrders => {
  const detailsOrder = {
    billingModel: order.billingModel,
    distance: order.distance,
    haltingTime: order.haltingTime,
    humanId: order.humanId,
    startTime: order.startTime,
    taxiCorporation: order.taxiCorporation,
    totalTime: order.totalTime,
  };
  return detailsOrder;
};

const createOrders = (
  orders: OrderOptimizerDetailsCargoResponseItemOrders[]
): OrderOptimizerDetailsCargoOrders[] => {
  return orders.map(createOrder);
};

const create = (
  response: OrderOptimizerDetailsCargoResponse
): OrderOptimizerDetailsCargo => {
  return {
    optimizedStats: createOptimizedStats(response.data.optimizedStats),
    orders: createOrders(response.data.orders),
    reviewedAt: response.data.reviewedAt,
    reviewedBy: response.data.reviewedBy,
    steps: createSteps(response.data.steps),
    unoptimizedStats: createUnoptimizedStats(response.data.unoptimizedStats),
    score: response.data.score,
  };
};

const orderOptimizerDetailsCargoFactory = {
  create,
};

export default orderOptimizerDetailsCargoFactory;
